import { faWandMagicSparkles } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";

const AiGeneratedBadge = withLiteObserverAndTheme<{
  isGeneratedByAi: number;
}>((props) => {
  const { isGeneratedByAi, theme } = props;
  const { colors, unitX } = theme;

  if (isGeneratedByAi !== 1) {
    return null;
  }

  return (
    <FontAwesomeIcon
      icon={faWandMagicSparkles}
      style={{ color: colors.all.bondiBlue, marginLeft: 8 * unitX }}
    />
  );
});

export default AiGeneratedBadge;
